import { createElementBlock as o, openBlock as l, createElementVNode as t } from "vue";
import r from "./index289.js";
const n = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(p, e, a, i, m, d) {
  return l(), o("svg", s, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "m12 2.25-.276.004C6.449 2.407 2.25 6.722 2.25 12l.004.276C2.407 17.551 6.722 21.75 12 21.75l.276-.004c5.275-.153 9.474-4.468 9.474-9.746l-.004-.276C21.593 6.449 17.278 2.25 12 2.25Z"
    }, null, -1),
    t("path", {
      fill: "#FFF",
      d: "M16 11.25a.75.75 0 0 1 .102 1.493L16 12.75H8a.75.75 0 0 1-.102-1.493L8 11.25h8Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(n, [["render", c]]);
export {
  u as default
};
